import { Trans } from 'react-i18next'

import brainSurgeryPNG from '~/assets/images/anatomy/brain-surgery.png'
import brainSurgeryWEBP from '~/assets/images/anatomy/brain-surgery.webp'
import {
  ANSWERS,
  BRAIN_PAIN_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/anatomy/quizBinaryChoice/libs/styles'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const BrainPain = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: BRAIN_PAIN_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <PS.Question>
          <Trans ns="anatomy" i18nKey="onboarding.brainPain.question" />
        </PS.Question>

        <PS.ImageWrapper>
          <picture>
            <source srcSet={brainSurgeryWEBP} type="image/webp" />
            <img src={brainSurgeryPNG} alt="Brain pain receptors" />
          </picture>
        </PS.ImageWrapper>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default BrainPain
